// extracted by mini-css-extract-plugin
export default {"menuItem":"styles_menuItem__E-ZzM","menuOverlay":"styles_menuOverlay__jxM2G","fileOptionsDropdown":"styles_fileOptionsDropdown__EqtsP"};